export function mergeUrlParms(params1, params2) {
    return new URLSearchParams({
        ...Object.fromEntries(params1),
        ...Object.fromEntries(params2),
    });
}
//# sourceMappingURL=url.js.map